import useElement from "backend/hooks/elements/useElement";
import useScorecardTopElement from "backend/hooks/model/useScorecardTopElement";
import PeriodSelector from "components/PeriodSelector";
import ToolbarTitle from "design/components/texts/ToolbarTitle";
import Tabs from "design/components/toolbar/Tabs";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import Center from "design/layouts/Center";
import Right from "design/layouts/Right";
import SplitView from "design/layouts/SplitView";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import { getFileApiURL } from "qpr-base/utils/url-utils";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import { t } from "i18next";
import { getTranslatedAttribute } from "qpr-base//tplutils/utils";

const useIconStyles = makeThemedStyles("StrategyToolbarIcon", (theme) => ({
  root: {
    marginLeft: 0,
    marginRight: "15px",
    marginTop: "5px",
    width: "50px",
    height: "50px",
    backgroundImage: `url(${getFileApiURL(`/icons/navitems/corporate.svg`)})`,
  },
}));

const StrategyToolbar = (props: { selected?: string }) => {
  const { data: root } = useScorecardTopElement("L0");

  const ctx = useAppContext();
  const link = useLink();
  const { data, isLoading } = useElement(ctx.elementId || root?.id);
  const [anchorEl, setAnchorEl] = React.useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);
  const [fileType, setFileType] = React.useState<string | null>();
  const [isExporting, setIsExporting] = React.useState<boolean>(false);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleSelectFile = (type: string) => {
    setFileType(type);
    setAnchorEl(null);
    setIsExporting(true);
  };

  const iconstyles = useIconStyles();
  return (
    <ToolbarContainer>
      <SplitView partCnt={3}>
        <ToolbarTitle>
          <span className={iconstyles.root}></span>
          {data ? getTranslatedAttribute(data, "Name", ctx.language) : ""}
        </ToolbarTitle>
        <Center>
          <Tabs
            onChange={(value) => {
              link({
                page: value,
              });
            }}
            selected={props.selected || ctx.page || "overview"}
            options={[
				{
					viewName: "strategymap",
					title: t("toolbar.Strategy Map"),
				},
				{
					viewName: "overview",
					title: t("toolbar.Overview"),
				},
				{
					viewName: "kpis",
					title: t("toolbar.KPIs"),
				},
				{
					viewName: "initiatives",
					title: t("toolbar.Initiatives"),
				},




            ]}
          />
        </Center>
        <Right>
          <PeriodSelector />
        </Right>
      </SplitView>
    </ToolbarContainer>
  );
};

export default StrategyToolbar;
